import { Box, Icon } from '@chakra-ui/react';

import { FaPlus } from 'react-icons/fa6';

import SectionAction from '../../components/SectionAction';
import SectionPanel from '../../components/SectionPanel';
import SectionPlaceholder from '../../components/SectionPlaceholder';

interface QuotesProps {
  customerId: string;
}

const Quotes = ({ customerId }: QuotesProps) => {
  return (
    <SectionPanel
      title="Quotes"
      collapsible
      action={<SectionAction label="New Quote" icon={<Icon as={FaPlus} />} />}
    >
      <Box data-customer-id={customerId}>
        <SectionPlaceholder label="Quotes" />
      </Box>
    </SectionPanel>
  );
};

export default Quotes;
